import React from 'react';
import { Link } from 'react-router-dom';

const containerStyle = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '80px 20px 40px 20px',
  color: '#1d1d1f',
  lineHeight: '1.6',
};

const titleStyle = {
  fontSize: '2.5rem',
  fontWeight: '600',
  marginBottom: '2rem',
  color: '#1d1d1f',
};

const sectionStyle = {
  marginBottom: '2rem',
};

const headingStyle = {
  fontSize: '1.5rem',
  fontWeight: '600',
  marginTop: '2rem',
  marginBottom: '1rem',
  color: '#1d1d1f',
};

const paragraphStyle = {
  marginBottom: '1rem',
  fontSize: '15px',
  color: '#86868b',
};

const linkStyle = {
  color: '#0071e3',
  textDecoration: 'none',
};

const lastUpdatedStyle = {
  fontSize: '13px',
  color: '#86868b',
  fontStyle: 'italic',
  marginBottom: '2rem',
};

export default function PrivacyPolicy() {
  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Privacy Policy</h1>
      <p style={lastUpdatedStyle}>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>1. Introduction</h2>
        <p style={paragraphStyle}>
          Welcome to MyPictor. We respect your privacy and are committed to protecting your personal data. 
          This privacy policy explains how we collect, use, disclose, and safeguard your information when you 
          use our photo cataloging desktop application and related services.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>2. Information We Collect</h2>
        <p style={paragraphStyle}>
          <strong>2.1 Personal Information:</strong> We may collect personal information that you provide 
          directly to us, including but not limited to your name, email address, and any other information 
          you choose to provide when creating an account or contacting us.
        </p>
        <p style={paragraphStyle}>
          <strong>2.2 Photo Metadata:</strong> Our application processes metadata associated with your photos, 
          including EXIF data, file names, dates, and locations. This information is used solely to organize 
          and catalog your photos within the application.
        </p>
        <p style={paragraphStyle}>
          <strong>2.3 Usage Data:</strong> We may collect information about how you access and use our application, 
          including device information, IP address, browser type, and usage patterns.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>3. How We Use Your Information</h2>
        <p style={paragraphStyle}>
          We use the information we collect to:
        </p>
        <ul style={{ ...paragraphStyle, paddingLeft: '20px' }}>
          <li>Provide, maintain, and improve our services</li>
          <li>Process and organize your photos</li>
          <li>Respond to your inquiries and provide customer support</li>
          <li>Send you technical notices and updates</li>
          <li>Detect, prevent, and address technical issues</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>4. Data Storage and Security</h2>
        <p style={paragraphStyle}>
          <strong>4.1 Local Storage:</strong> Your photos and associated data are stored locally on your device. 
          We do not upload your photos to our servers unless you explicitly choose to use cloud-based features.
        </p>
        <p style={paragraphStyle}>
          <strong>4.2 Security Measures:</strong> We implement appropriate technical and organizational measures 
          to protect your personal information. However, no method of transmission over the internet or electronic 
          storage is 100% secure.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>5. Data Sharing and Disclosure</h2>
        <p style={paragraphStyle}>
          We do not sell, trade, or rent your personal information to third parties. We may share your information 
          only in the following circumstances:
        </p>
        <ul style={{ ...paragraphStyle, paddingLeft: '20px' }}>
          <li>With your explicit consent</li>
          <li>To comply with legal obligations or respond to lawful requests</li>
          <li>To protect our rights, privacy, safety, or property</li>
          <li>In connection with a business transfer or merger</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>6. Your Rights</h2>
        <p style={paragraphStyle}>
          Depending on your location, you may have certain rights regarding your personal information, including:
        </p>
        <ul style={{ ...paragraphStyle, paddingLeft: '20px' }}>
          <li>The right to access your personal data</li>
          <li>The right to rectify inaccurate data</li>
          <li>The right to request deletion of your data</li>
          <li>The right to object to processing of your data</li>
          <li>The right to data portability</li>
        </ul>
        <p style={paragraphStyle}>
          To exercise these rights, please contact us using the information provided in the Contact section below.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>7. Third-Party Services</h2>
        <p style={paragraphStyle}>
          Our application may integrate with third-party services. These services have their own privacy policies, 
          and we encourage you to review them. We are not responsible for the privacy practices of third-party services.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>8. Children's Privacy</h2>
        <p style={paragraphStyle}>
          Our services are not intended for children under the age of 13. We do not knowingly collect personal 
          information from children under 13. If you believe we have collected information from a child under 13, 
          please contact us immediately.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>9. Changes to This Privacy Policy</h2>
        <p style={paragraphStyle}>
          We may update this privacy policy from time to time. We will notify you of any changes by posting the 
          new privacy policy on this page and updating the "Last Updated" date. You are advised to review this 
          privacy policy periodically for any changes.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>10. Contact Us</h2>
        <p style={paragraphStyle}>
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p style={paragraphStyle}>
          Email: privacy@mypictor.com<br />
          Website: <Link to="/" style={linkStyle}>www.mypictor.com</Link>
        </p>
      </section>
    </div>
  );
}

